export const resolveUiTheme = ({ enabled, preference, nightStart, nightEnd, now = new Date() }) => {
  if (String(enabled) !== "true") return "light";
  if (preference === "dark") return "dark";
  if (preference !== "auto") return "light";
  const hour = now.getHours();
  const start = Number(nightStart);
  const end = Number(nightEnd);
  const nightFrom = Number.isFinite(start) ? start : 19;
  const nightTo = Number.isFinite(end) ? end : 7;
  if (nightFrom === nightTo) return "light";
  if (nightFrom > nightTo) {
    return hour >= nightFrom || hour < nightTo ? "dark" : "light";
  }
  return hour >= nightFrom && hour < nightTo ? "dark" : "light";
};
